import { useQuery } from 'react-query'
import { hasValidProfile } from '../../apis/private.api';


function useValidateProfile(email: string) {
  return useQuery('validate-profile', async () => {
    const { verify } = await hasValidProfile(email)

    return verify
  })
}

export { useValidateProfile }
